// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a-JF","right":"styles_right__1KhpU"};